import { TemplateResult, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js'
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import encapsulatedStyles from './styles/outline-signup-block.inner.pcss?inline';
import globalStyles from './styles/outline-signup-block.global.pcss?inline';
import '../outline-cta/outline-cta';
import '../outline-svg/outline-svg';
import '../outline-container/outline-container';


/**
 * The OutlineSignupBlock component
 * @element outline-signup-block
 */
@customElement('outline-signup-block')
export class OutlineSignupBlock extends LitElement {
  adoptedStyleSheets = new AdoptedStyleSheets(this, {
    encapsulatedCSS: encapsulatedStyles,
    globalCSS: globalStyles,
  });

  @property({type: Boolean, reflect: true, attribute: 'form-open'})
  formOpen: boolean = false;

  @property({type: String, attribute: 'cta-label', reflect: true})
  ctaLabel: string;

  render(): TemplateResult {
    return html`
      <section class="outline-signup-block">
        <outline-container background-color="brand-secondary" y-padding="space-0">
          <div class="content-wrapper">
            <div class="headline-wrapper">
              <slot name="heading"></slot>
              <slot name="description"></slot>
              <span class="requirement-label">* indicates required field</span>
            </div>
            <div class="button-wrapper">
              <button
                class="outline-cta outline-cta--button-primary"
                aria-haspopup="true"
                aria-expanded=${this.formOpen}
                @click=${this.toggleFormOpen}
              >
                <span>${this.ctaLabel ? this.ctaLabel : 'Sign up'}</span>
                <outline-svg name=${this.formOpen ? "circleMinus" : "circleCross"} svg-fill="var(--background-neutral-subtlest)" size="16px" ></outline-svg>
              </button>
            </div>
          </div>
          <div class="form-wrapper">
            <slot aria-hidden="${!this.formOpen}" name="form"></slot>
          </div>
        </outline-container>
      </section>
    `;
  }

  toggleFormOpen() {
    this.formOpen = !this.formOpen;
  }
}
